module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2018_10.8d1e4539.jpg";